import { render } from "./SaleModalSectionConfiguration.vue?vue&type=template&id=ff367342&scoped=true"
import script from "./SaleModalSectionConfiguration.vue?vue&type=script&lang=js"
export * from "./SaleModalSectionConfiguration.vue?vue&type=script&lang=js"

import "./SaleModalSectionConfiguration.vue?vue&type=style&index=0&id=ff367342&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff367342"]])

export default __exports__